module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/prizes.b237088e9d93dabc.png";